import { render } from "./readingGuide.vue?vue&type=template&id=196a82eb&scoped=true"
import script from "./readingGuide.vue?vue&type=script&lang=js"
export * from "./readingGuide.vue?vue&type=script&lang=js"

import "./readingGuide.vue?vue&type=style&index=0&id=196a82eb&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a82eb"]])

export default __exports__